import type { JourneyAlias } from '@hc-frontend/core-types';

export const journeyAliasToPath: Record<JourneyAlias, string> = {
  HEALTH_DEFAULT: 'healthcare-insurance',
  MEDICARE_GENERIC: 'medicare',
  MEDICARE_ADVANTAGE: 'medicare-advantage',
  MEDICARE_SUPPLEMENT: 'medicare-supplement',
  '95': 'medicare-supplement',
};
